import React from 'react';
import SurveyForm from './SurveyForm';

function App() {
  return (
    <div className="App">
      <SurveyForm />
    </div>
  );
}

export default App;